import { Modal, Input, Form } from 'antd';
import React, { useEffect } from 'react';

import { useCreateFolder } from '@/api';
import { showMessage } from '@/shared/utils';

interface CreateFolderModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  currentPath: string;
}

export function CreateFolderModal({
  isOpen,
  onCancel,
  onSuccess,
  currentPath,
}: CreateFolderModalProps) {
  const [form] = Form.useForm();
  const createFolderMutation = useCreateFolder();

  useEffect(() => {
    if (isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await createFolderMutation.mutateAsync({
        parentFolderPath: currentPath,
        name: values.name,
      });
      showMessage('success', 'Ordner erfolgreich erzeugt');
      onSuccess();
      onCancel();
    } catch (error: any) {
      if (error.response?.status === 409) {
        form.setFields([
          {
            name: 'name',
            errors: [error.response.data.message],
          },
        ]);
      } else {
        showMessage('error', error.message);
      }
    }
  };

  return (
    <Modal title='Neuer Ordner' open={isOpen} onOk={handleOk} onCancel={onCancel}>
      <Form form={form} layout='vertical'>
        <Form.Item
          name='name'
          rules={[
            { required: true, message: 'Bitte einen Namen angeben' },
            { max: 255, message: 'Es sind maximal 255 Zeichen erlaubt' },
            {
              pattern: /^[^\\/:*?"<>|]+$/,
              message: 'Name darf keine Sonderzeichen enthalten (\\ / : * ? " < > |)',
            },
          ]}
        >
          <Input placeholder='Ordnername' />
        </Form.Item>
      </Form>
    </Modal>
  );
}
